
import moment from 'moment'
import PropTypes from 'prop-types'
import TextField from '@mui/material/TextField'
import { MobileDatePicker } from '@mui/x-date-pickers'
import { themeV5 } from 'theme/v5'

const CustomDatePicker = ({
  fullWidth,
  variant,
  value,
  format,
  onChange,
  disabledPastDates,
  disableFuture,
  minDate,
  maxDate,
  textFieldClassName,
  helperText,
  ...rest
}) => {

  return (
    <>
      <style>
        {`
          .MuiPickersDay-dayWithMargin.Mui-disabled, .MuiPickersYear-yearButton.Mui-disabled {
            color: rgba(0, 0, 0, 0.26);
          }
          .MuiPickersDatePickerToolbar-root {
            padding-top: 10px;
          }
          .MuiGrid-root.MuiPickersToolbar-dateTitleContainer.MuiGrid-container.MuiGrid-align-items-xs-flex-end > h4 {
            color: #FFFFFF;
          }
          .MuiPickersDatePickerToolbar-penIcon {
            display: none;
          },
      `}
      </style>
      <MobileDatePicker
        {...rest}
        value={value}
        onChange={onChange}
        inputFormat={format || 'Do MMMM YYYY'}
        disablePast={disabledPastDates}
        disableFuture={disableFuture}
        minDate={minDate && moment(minDate)}
        maxDate={maxDate && moment(maxDate)}
        defaultValue={null}
        renderInput={(props) => (
          <div
            style={{
              position: 'relative',
            }}>
            <TextField
              {...props}
              fullWidth={fullWidth}
              variant={variant}
              sx={textFieldClassName || ''}
              helperText={helperText}/>

            {props.error && (
              <span
                style={{
                  position: 'absolute',
                  top: 40,
                  left: 0,
                  marginLeft: '14px',
                  marginRight: '14px',
                  color: themeV5.palette.error.main,
                  fontSize: '11px',
                  marginTop: '3px',
                  textAlign: 'left',
                  fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', sans-serif',
                  fontWeight: 400,
                  lineHeight: '13px',
                  letterSpacing: '0.33px',
                }}>
                Invalid variation date
              </span>
            )}
          </div>
        )}/>
    </>
  )
}

CustomDatePicker.propTypes = {
  fullWidth: PropTypes.bool,
  variant: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]).isRequired,
  format: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabledPastDates: PropTypes.bool,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  textFieldClassName: PropTypes.string,
  helperText: PropTypes.string,
}

export default CustomDatePicker
